import React, { useState } from "react";
import { FaCloud, FaMobileAlt, FaCode, FaLock, FaChartLine, FaCogs } from "react-icons/fa";
import { motion } from "framer-motion";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
const servicesData = [
    {
        category: "Cloud Solutions",
        icon: <FaCloud size={32} />,
        services: [
            {
                title: "Cloud Migration",
                description: "Seamless migration of your infrastructure and applications to the cloud.",
            },
            {
                title: "Cloud Native Development",
                description: "Build scalable, resilient cloud-native applications.",
            },
        ],
    },
    {
        category: "Mobile & Web Development",
        icon: <FaMobileAlt size={32} />,
        services: [
            {
                title: "Mobile App Development",
                description: "Custom iOS and Android app development for your business.",
            },
            {
                title: "Web Application Development",
                description: "Modern, responsive web applications tailored to your needs.",
            },
        ],
    },
    {
        category: "Custom Software",
        icon: <FaCode size={32} />,
        services: [
            {
                title: "Enterprise Software",
                description: "Robust software solutions for enterprise-level requirements.",
            },
            {
                title: "API Development",
                description: "Secure and scalable API design and implementation.",
            },
        ],
    },
    {
        category: "Cybersecurity",
        icon: <FaLock size={32} />,
        services: [
            {
                title: "Security Audits",
                description: "Comprehensive security assessments for your IT assets.",
            },
            {
                title: "Data Protection",
                description: "Implement best practices for data privacy and protection.",
            },
        ],
    },
    {
        category: "Data & Analytics",
        icon: <FaChartLine size={32} />,
        services: [
            {
                title: "Business Intelligence",
                description: "Transform data into actionable insights.",
            },
            {
                title: "Data Engineering",
                description: "Build and maintain scalable data pipelines.",
            },
        ],
    },
    {
        category: "DevOps & Automation",
        icon: <FaCogs size={32} />,
        services: [
            {
                title: "CI/CD Implementation",
                description: "Automate your software delivery pipeline.",
            },
            {
                title: "Infrastructure as Code",
                description: "Provision and manage infrastructure with code.",
            },
        ],
    },
];

const tabVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

const Servicespage = () => {
    const [activeTab, setActiveTab] = useState(0);
const navigate = useNavigate();
    return (
        <>
           
            <Container className="py-5">
                <Row className="justify-content-center mb-4">
                    <Col md={8} className="text-center">
                        <h1 className="mb-3">Minix IT Hub Services</h1>
                        <p className="lead">
                            Empowering your business with innovative IT solutions. Explore our wide range of services designed to accelerate your digital transformation.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col md={4} className="mb-4">
                        <Nav variant="pills" className="flex-column">
                            {servicesData.map((cat, idx) => (
                                <Nav.Item key={cat.category}>
                                    <Nav.Link
                                        active={activeTab === idx}
                                        onClick={() => setActiveTab(idx)}
                                        className="d-flex align-items-center mb-2"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <span className="me-2">{cat.icon}</span>
                                        <span>{cat.category}</span>
                                    </Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                    </Col>
                    <Col md={8}>
                        <motion.div
                            key={activeTab}
                            initial="hidden"
                            animate="visible"
                            variants={tabVariants}
                        >
                            <Row>
                                {servicesData[activeTab].services.map((srv, i) => (
                                    <Col md={6} key={srv.title} className="mb-4">
                                        <motion.div
                                            initial={{ opacity: 0, x: 40 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            transition={{ delay: i * 0.1 }}
                                        >
                                            <Card className="h-100 shadow-sm">
                                                <Card.Body>
                                                    <Card.Title>{srv.title}</Card.Title>
                                                    <Card.Text>{srv.description}</Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </motion.div>
                                    </Col>
                                ))}
                            </Row>
                        </motion.div>
                    </Col>
                </Row>

                 <Row className="justify-content-center mb-4">
                    <Col md={8} className="text-center">
                    <h3>Let’s get started</h3>
                        <h1 className="mb-3">Are you ready for a better, more productive business?</h1>
                        <p className="lead h4">
                            Stop worrying about technology problems. Focus on your business.
Let us provide the support you deserve.
Contact us Now
                        </p>
                        <Button onClick={()=>navigate("/contact") } variant="primary" size="lg">Contact Us</Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Servicespage;